<template>
  <div
    v-if="exam.id"
  >
    <exam-direction-breadcrumb :direction-id="Number($route.params.directionId)" />
    <apply-document-component
      :apply-documents="applyDocuments"
      @selectApplyDoc="selectApplyDoc"
    />
    <apply-document-update-component
      ref="refApplyDocumentUpdate"
      :is-first-quarter="isFirstQuarter()"
      @refetchData="refetchData"
    />
    <result-exam-list-component
      ref="refResultExamListComponent"
      :is-first-quarter="isFirstQuarter()"
      :exam-results="examResults"
      @removeExamResult="removeExamResult"
      @addAsAdditional="addAsAdditional"
      @removeFromAdditional="removeFromAdditional"
    />
  </div>
</template>

<script>
import { VBToggle } from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import examModule from '@/store/exam/index'
import examResultModule from '@/store/exam-result/index'
import store from '@/store'
import applyDocumentModule from '@/store/apply-document'
import applyDocumentComponent from './component/ApplyDocumentListComponent.vue'
import applyDocumentUpdateComponent from './component/ApplyDocumentUpdateComponent.vue'
import ResultExamListComponent from './component/ResultExamListComponent.vue'
import ExamDirectionBreadcrumb from '@/views/pages/exam/component/ExamDirectionBreadcrumb.vue'

export default {
  directives: {
    'b-toggle': VBToggle,
  },
  components: {
    ExamDirectionBreadcrumb,
    applyDocumentComponent,
    applyDocumentUpdateComponent,
    ResultExamListComponent,
  },
  computed: {
    exam() {
      return this.$store.state[this.MODULE_NAME].exam
    },
    applyDocuments() {
      return this.$store.state[this.MODULE_APPLY_DOCUMENT].applyDocuments
    },
    examResults() {
      return this.$store.state[this.MODULE_EXAM_RESULT].examResults
    },
  },
  created() {
    this.refetchData()
  },
  methods: {
    refetchData() {
      this.$store.commit(`${this.MODULE_NAME}/FRESH`)
      this.$store.dispatch(`${this.MODULE_NAME}/get`, this.$route.params.id).then(() => {
        this.loadApplyDocuments()
        this.loadExamResults()
      }).catch(err => {
        this.$errorSwal(this, err)
      })
    },
    loadApplyDocuments() {
      this.$store.dispatch(`${this.MODULE_APPLY_DOCUMENT}/list`, {
        quarter: this.exam.quarter.id,
        direction: this.$route.params.directionId,
        limit: this.MAX_LIMIT,
        is_exam: 'True',
      })
    },
    loadExamResults() {
      this.$store.dispatch(`${this.MODULE_EXAM_RESULT}/list`, {
        exam_id: this.exam.id,
        direction_id: this.$route.params.directionId,
        limit: this.MAX_LIMIT,
      })
    },
    selectApplyDoc(data) {
      this.$store.commit(`${this.MODULE_APPLY_DOCUMENT}/SET`, data)
      this.$store.commit(`${this.MODULE_EXAM_RESULT}/UPLOAD_EXAM_RESULT`, {
        apply_doc: data.id,
        exam: this.exam.id,
      })
      this.$root.$emit('bv::toggle::collapse', 'sidebar-update-apply-document')
      this.$refs.refApplyDocumentUpdate.loadData()
    },
    isFirstQuarter() {
      return this.exam.quarter.quarter === 1
    },
    removeExamResult(data) {
      this.$removeSwal(this, data, `${this.MODULE_EXAM_RESULT}/del`, () => {
        this.loadApplyDocuments()
        this.loadExamResults()
      }, {
        text: '',
      })
    },
    addAsAdditional(data) {
      this.$removeSwal(this, data, `${this.MODULE_EXAM_RESULT}/addAdditional`, () => {
        this.loadExamResults()
      }, {
        text: '',
        errorText: '',
        confirmButtonText: 'Yes, confirm it!',
        successTitle: 'Accepted!',
        successText: '',
      })
    },
    removeFromAdditional(data) {
      this.$removeSwal(this, data, `${this.MODULE_EXAM_RESULT}/removeAdditional`, () => {
        this.loadExamResults()
      }, {
        text: '',
        errorText: '',
        confirmButtonText: 'Yes, confirm it!',
        successTitle: 'Accepted!',
        successText: '',
      })
    },
  },
  setup() {
    const MODULE_NAME = 'exam'
    const MODULE_APPLY_DOCUMENT = 'applyDocument'
    const MODULE_EXAM_RESULT = 'examResult'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, examModule)
    if (!store.hasModule(MODULE_APPLY_DOCUMENT)) store.registerModule(MODULE_APPLY_DOCUMENT, applyDocumentModule)
    if (!store.hasModule(MODULE_EXAM_RESULT)) store.registerModule(MODULE_EXAM_RESULT, examResultModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
      if (store.hasModule(MODULE_APPLY_DOCUMENT)) store.unregisterModule(MODULE_APPLY_DOCUMENT)
      if (store.hasModule(MODULE_EXAM_RESULT)) store.unregisterModule(MODULE_EXAM_RESULT)
    })
    return {
      MODULE_NAME,
      MODULE_APPLY_DOCUMENT,
      MODULE_EXAM_RESULT,
    }
  },
}
</script>
